import { GeofenceRequestType } from "../../../types/types";
import { api } from "../api";

type TicketRequestType = {
    id: number;
    name: string;
    description: string;
    typeId: number;
    gravityId: number;
    files: Array<any>;
    departmentId: number;
    customerReducedName: string;
};

/**
 * ticketSaveByDepartment - Function that saves on database a new ticket by department   
 * /tickets  
 * method POST  
 * @async-function
 */
const ticketSaveByDepartment = async (token: string, model: TicketRequestType) => {
    const response = await api.post(
        `/tickets`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default ticketSaveByDepartment;